import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync } from "../../utilities/customHooks";
import LoadingIndicator from "../../Components/LoadingIndicator";
import ErrorIndicator from "../../Components/ErrorIndicator";
import { getExpertAssesmentStats } from "../../services/ipExpertService";
import { useContext, useState } from "react";
import List from "../../Components/List";
import * as T from "../../utilities/frontendTypes";
import Button from "../../Components/Button";
import { inputClasses } from "../../Components/Form/InputField";
import { updateCalednlyLink } from "../../services/ipExpertService";
import { handleFormSaveResponse } from "../../utilities/helperFunctions";


const IpExpertDashboard = () => {
  const [updatingCalednly, setUpDatingCalednly] = useState(false)
  const [inputValueCalendly, setInputValueCalendly] = useState("")
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const [reloadOnSave, setReloadOnSave] = useState(false)
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;

  const navigate = useNavigate();
  const columnHeaderData = [
    {
      header: "Startup",
      key: "companyName"
    },
    {
      header: "Status",
      key: "actionItem",
      sortOptions: ["New Assessment Request", "Invite Sent", "Ongoing Assessment", "Board Review", "Submitted Assessment", "Complete", "SoW Awaiting Approval"]
    },
    {
      header: "Last Updated",
      key: "lastUpdated"
    },
    {
      header: "Contact",
      key: "contactPerson"
    }
  ]

  const founderDetailsAsync = useAsync(() => getExpertAssesmentStats(), [reloadOnSave]);

  if (founderDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (founderDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const handleViewMemberDetails = (appId: string) => {
    navigate((`/dashboard/expert-assessments/${appId}`));
  }

  const contentArray = founderDetailsAsync.value.foundersArray;


  async function saveUpdateCalendlyLink() {
    showLoading();
    const response = await updateCalednlyLink(inputValueCalendly);  
    hideLoading();

    if (response.success) {
      setUpDatingCalednly(false)
      setInputValueCalendly("")
      setReloadOnSave(!reloadOnSave)
    }
    
  }

  return (
    <div className="resourcesCont !pt-0 !gap-0 h-full">
      <h2 className="">Welcome Back, {founderDetailsAsync.value.name}</h2>
      <div className="w-full mt-4 mb-8">
        {updatingCalednly ? 
        <div className="flex gap-4 w-full flex-wrap md:flex-nowrap">
          <input 
            type="text" 
            value={inputValueCalendly} 
            onChange={(e) => setInputValueCalendly(e.target.value)} 
            placeholder="New Calendly Link" 
            className={ `${inputClasses} !min-w-[300px] !inline-block`}
          />
          <div className="flex gap-4">
            <Button 
              buttonText="Save"
              actionHandler={() => saveUpdateCalendlyLink()}
            />
            <Button 
              buttonText="Cancel"
              actionHandler={() => setUpDatingCalednly(false)}
              buttonType="secondary"
            />
          </div>
        </div>
        :
        <div className="flex flex-wrap items-center w-full justify-between gap-4">
          <p className="bodyLarger">Your Calendly Link: <a className="underline" target="_blank" href={founderDetailsAsync.value.link}>{founderDetailsAsync.value.link}</a></p>
          <Button 
            buttonText="Update Link"
            actionHandler={() => setUpDatingCalednly(true)}
            size="small"
          />
        </div>
        }
      </div>
      <List 
        contentArray={contentArray}
        columnHeaderData={columnHeaderData}
        returnDetailsId={handleViewMemberDetails}
        detailsIdName="appId"
        isReverse
      />
    </div>
  )
}

export default IpExpertDashboard